"use strict";
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var classNames = require("classnames");
var PureRender = require("pure-render-decorator");
var React = require("react");
var Classes = require("../../common/classes");
var Elevation;
(function (Elevation) {
    Elevation[Elevation["ZERO"] = 0] = "ZERO";
    Elevation[Elevation["ONE"] = 1] = "ONE";
    Elevation[Elevation["TWO"] = 2] = "TWO";
    Elevation[Elevation["THREE"] = 3] = "THREE";
    Elevation[Elevation["FOUR"] = 4] = "FOUR";
})(Elevation = exports.Elevation || (exports.Elevation = {}));
var ELEVATION_CLASSES = [
    Classes.ELEVATION_0,
    Classes.ELEVATION_1,
    Classes.ELEVATION_2,
    Classes.ELEVATION_3,
    Classes.ELEVATION_4,
];
var Card = (function (_super) {
    tslib_1.__extends(Card, _super);
    function Card() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Card.prototype.render = function () {
        return (React.createElement("div", { className: this.getClassName(), onClick: this.props.onClick }, this.props.children));
    };
    Card.prototype.getClassName = function () {
        var _a = this.props, elevation = _a.elevation, interactive = _a.interactive, className = _a.className;
        return classNames(Classes.CARD, (_b = {}, _b[Classes.INTERACTIVE] = interactive, _b), ELEVATION_CLASSES[elevation], className);
        var _b;
    };
    Card.displayName = "Blueprint.Card";
    Card.defaultProps = {
        elevation: Elevation.ZERO,
        interactive: false,
    };
    Card = tslib_1.__decorate([
        PureRender
    ], Card);
    return Card;
}(React.Component));
exports.Card = Card;



//////////////////
// WEBPACK FOOTER
// ./~/@blueprintjs/core/dist/components/card/card.js
// module id = 333
// module chunks = 168707334958949